<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>
<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
        v-if="this.isEdit == true"
      >
        แก้ไข ตช.
      </div>
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
        v-else
      >
        เพิ่มข้อมูล ตช.
      </div>

      <v-spacer></v-spacer>

      <v-btn
        outlined
        color="indigo"
        style="margin-right: 10px"
        elevation="0"
        dark
        @click="backTO"
        >ย้อนกลับ
      </v-btn>
      <v-btn
        color="success"
        elevation="0"
        dark
        v-if="this.GET_IS_EDIT == true"
        @click="saveupdate"
      >
        <v-icon left>mdi-file-plus</v-icon>บันทึกการแก้ไข
      </v-btn>
      <v-btn color="success" elevation="0" dark @click="save" v-else>
        <v-icon left>mdi-file-plus</v-icon>บันทึก
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-row>
        <v-col cols="12" lg="6">
          ชื่อลูกค้า :
          <v-combobox
            dense
            outlined
            v-model="W_NAME"
            :rules="setCar_Rules"
            :items="cusList"
            item-text="CUSTOMER_NAME"
            item-value="NEWCUSTOMER_ID"
            return-object
            prepend-icon="mdi-file-account-outline"
          ></v-combobox>
        </v-col>
        <v-col cols="12" lg="3">
          ทะเบียนรถ :
          <v-combobox
            color="black"
            :items="carList"
            v-model="W_CARNUMBER"
            item-text="CAR_NUMBER"
            item-value="CAR_NUMBER"
            :rules="setCar_Rules"
            outlined
            dense
            return-object
            prepend-icon="mdi-card-bulleted"
          ></v-combobox>
        </v-col>
        <v-col cols="12" lg="3">
          คนขับ :
          <v-combobox
            dense
            outlined
            v-model="W_DRIVER"
            :rules="setCar_Rules"
            :items="driverList"
            item-text="PNAME"
            item-value="PERSONNEL_CID"
            return-object
            prepend-icon="mdi-account-details"
          ></v-combobox>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          คนขน :
          <v-combobox
            dense
            outlined
            v-model="W_CARRIER"
            :rules="setCar_Rules"
            :items="carierList"
            item-text="PNAME"
            item-value="PERSONNEL_CID"
            return-object
            prepend-icon="mdi-account-circle"
          ></v-combobox>
        </v-col>

        <v-col cols="12" lg="3" class="mt-n10">
          วันที่เก็บขน :
          <date-picker
            color="black"
            class="mb-1"
            style="width: 100%"
            v-model="W_DATE_I"
            :format="momentFormat"
          ></date-picker>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          เวลาเข้า :
          <v-dialog
            ref="dialog_IN"
            v-model="modal2"
            :return-value.sync="W_TIME_I"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="W_TIME_I"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal2"
              v-model="W_TIME_I"
              format="24hr"
              full-width
            >
              <v-spacer></v-spacer>
              <v-btn text color="error" @click="modal2 = false"> ยกเลิก </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog_IN.save(W_TIME_I)"
              >
                ตกลง
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          เวลาออก :
          <v-dialog
            ref="dialog_OUT"
            v-model="modal3"
            :return-value.sync="W_TIME_O"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="W_TIME_O"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal3"
              v-model="W_TIME_O"
              format="24hr"
              full-width
            >
              <v-spacer></v-spacer>
              <v-btn text color="error" @click="modal3 = false"> ยกเลิก </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog_OUT.save(W_TIME_O)"
              >
                ตกลง
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          รถเปลี่ยนถ่าย :
          <v-combobox
            color="black"
            :items="carList"
            v-model="C_CARNUMBER"
            item-text="CAR_NUMBER"
            item-value="CAR_NUMBER"
            :rules="setCar_Rules"
            outlined
            dense
            return-object
            prepend-icon="mdi-card-bulleted"
          ></v-combobox>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          วันที่เปลี่ยนถ่าย :
          <date-picker
            color="black"
            class="mb-1"
            style="width: 100%"
            v-model="C_DATE"
            :format="momentFormat"
          ></date-picker>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          เวลาเปลี่ยนถ่าย :
          <v-dialog
            ref="dialog_CHANGE"
            v-model="modal4"
            :return-value.sync="C_TIME"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="C_TIME"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal4"
              v-model="C_TIME"
              format="24hr"
              full-width
            >
              <v-spacer></v-spacer>
              <v-btn text color="error" @click="modal4 = false"> ยกเลิก </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog_CHANGE.save(C_TIME)"
              >
                ตกลง
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (รวม):
          <v-text-field
            dense
            outlined
            v-model.number="W_WEIGHT"
            :rules="setCar_Rules"
            prepend-icon="mdi-weight-kilogram"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (เคมี-เคมี):
          <v-text-field
            dense
            outlined
            v-model.number="CHEMICAL_WEIGHT11"
            :rules="setCar_Rules"
            prepend-icon="mdi-chemical-weapon"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (เคมี-ไซลีน):
          <v-text-field
            dense
            outlined
            v-model.number="CHEMICAL_WEIGHT12"
            :rules="setCar_Rules"
            prepend-icon="mdi-chemical-weapon"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (เคมี-แอมป์ยา):
          <v-text-field
            dense
            outlined
            v-model.number="CHEMICAL_WEIGHT13"
            :rules="setCar_Rules"
            prepend-icon="mdi-chemical-weapon"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (เคมี-เคมีอื่นๆ):
          <v-text-field
            dense
            outlined
            v-model.number="CHEMICAL_WEIGHT14"
            :rules="setCar_Rules"
            prepend-icon="mdi-chemical-weapon"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (ติดเชื้อ-ขยะติดเชื้อ):
          <v-text-field
            dense
            outlined
            v-model.number="INFECTIOUS_WEIGHT21"
            :rules="setCar_Rules"
            prepend-icon="mdi-hospital"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (ติดเชื้อ-เข็ม):
          <v-text-field
            dense
            outlined
            v-model.number="INFECTIOUS_WEIGHT22"
            :rules="setCar_Rules"
            prepend-icon="mdi-hospital"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (ติดเชื้อ-ชิ้นเนื้อ):
          <v-text-field
            dense
            outlined
            v-model.number="INFECTIOUS_WEIGHT23"
            :rules="setCar_Rules"
            prepend-icon="mdi-hospital"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (ติดเชื้อ-ติดเชื้อ อื่นๆ):
          <v-text-field
            dense
            outlined
            v-model.number="INFECTIOUS_WEIGHT24"
            :rules="setCar_Rules"
            prepend-icon="mdi-hospital"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (อันตราย-อันตราย):
          <v-text-field
            dense
            outlined
            v-model.number="DANGER_WEIGHT31"
            :rules="setCar_Rules"
            prepend-icon="mdi-biohazard"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" class="mt-n10">
          น้ำหนัก (อันตราย-อันตราย อื่นๆ):
          <v-text-field
            dense
            outlined
            v-model.number="DANGER_WEIGHT32"
            :rules="setCar_Rules"
            prepend-icon="mdi-biohazard"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-divider></v-divider>
    </v-form>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: `carrier-form`,
  data() {
    return {
      carList: "",
      modal2: false,
      modal3: false,
      modal4: false,
      setCar_Rules: [(v) => !!v || ""],
      valid: false,
      lazy: false,
      cusList: "",
      carierList: "",
      driverList: "",
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date
            ? moment(date)
                .add(543, "year")
                .locale("th")
                .format("LL")
            : "";
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
      },
      momentTimeFormat: {
        // Date to String
        stringify: (date) => {
          return date
            ? moment(date)
                .add(543, "year")
                .locale("th")
                .format("h:mm:ss a")
            : "";
        },
      },
      isEdit: false,
    };
  },
  methods: {
    ...mapMutations({
      SET_ELEMENT: "Waste/SET_ELEMENT",
      LOADER: "Drawer/SET_LOADER",
    }),
    save() {
      if (
        this.getWaste.W_NAME.NEWCUSTOMER_ID == "" ||
        this.getWaste.W_NAME.NEWCUSTOMER_ID == null
      ) {
        this.$swal("กรุณาเลือลูกค้า", "", "warning");
      } else if (
        this.getWaste.W_CARNUMBER.CAR_CODE == "" ||
        this.getWaste.W_CARNUMBER.CAR_CODE == null
      ) {
        this.$swal("กรุณาเลือกรถ", "", "warning");
      } else if (
        this.getWaste.W_DRIVER.PERSONNEL_CID == "" ||
        this.getWaste.W_DRIVER.PERSONNEL_CID == null
      ) {
        this.$swal("กรุณาเลือกคนขับ", "", "warning");
      } else if (
        this.getWaste.W_CARRIER.PERSONNEL_CID == "" ||
        this.getWaste.W_CARRIER.PERSONNEL_CID == null
      ) {
        this.$swal("กรุณาเลือกคนขน", "", "warning");
      } else if (
        //   this.getWaste.W_CARNUMBER.CAR_ID == "" ||
        //   this.getWaste.W_CARNUMBER.CAR_ID == null
        // ) {
        //   this.$swal("กรุณาเลือกรถ", "", "warning");
        // } else if (
        this.getWaste.W_TIME_I == "" ||
        this.getWaste.W_TIME_I == null
      ) {
        this.$swal("กรุณากรอกเวลาเข้า", "", "warning");
      } else if (
        this.getWaste.W_TIME_O == "" ||
        this.getWaste.W_TIME_O == null
      ) {
        this.$swal("กรุณากรอกเวลาออก", "", "warning");
      } 
      // else if (!this.getWaste.C_CARNUMBER&&!this.getWaste.C_DATE&&!this.getWaste.C_TIME
      // ) {
      //   if (
      //     this.getWaste.C_CARNUMBER == "" ||
      //     this.getWaste.C_CARNUMBER == null
      //   ) {
      //     this.$swal("กรุณากรอกเลือกรถเปลี่ยนถ่าย", "", "warning");
      //   } else if (this.getWaste.C_DATE == "" || this.getWaste.C_DATE == null) {
      //     this.$swal("กรุณากรอกวันที่เปลี่ยนถ่าย", "", "warning");
      //   } else if (this.getWaste.C_TIME == "" || this.getWaste.C_TIME == null) {
      //     this.$swal("กรุณากรอกเวลาเปลี่ยนถ่าย", "", "warning");
      //   }
      // } 
      else if (
        this.getWaste.W_WEIGHT == "" ||
        this.getWaste.W_WEIGHT == null
      ) {
        this.$swal("กรุณากรอกน้ำหนักรวม", "", "warning");
      } else {
        let Insert_Waste = {
          CAR_CODE: this.getWaste.W_CARNUMBER.CAR_CODE,
          DRIVER: this.getWaste.W_DRIVER.PERSONNEL_CID,
          CARRIER: this.getWaste.W_CARRIER.PERSONNEL_CID,
          CAR: this.getWaste.W_CARNUMBER.CAR_ID,
          C_CAR: this.getWaste.C_CARNUMBER.CAR_ID,
          // CAR_ID: this.getWaste.W_CARNUMBER.CAR_ID,
          CUSTOMER_ID: this.getWaste.W_NAME.NEWCUSTOMER_ID,
          WALKIN_DATE: this.changeDate(
            this.getWaste.W_DATE_I,
            this.getWaste.W_TIME_I
          ),
          WALKUOT_DATE: this.changeDate(
            this.getWaste.W_DATE_I,
            this.getWaste.W_TIME_O
          ),
          CHANGE_DATE: this.changeDate(
            this.getWaste.C_DATE,
            this.getWaste.C_TIME
          ),
          WALKUOT_WEIGHT: checkweight(this.getWaste.W_WEIGHT),
          waste_detail: [
            {
              type_id: "11",
              wasteweigh: checkweight(this.getWaste.CHEMICAL_WEIGHT11),
            },
            {
              type_id: "12",
              wasteweigh: checkweight(this.getWaste.CHEMICAL_WEIGHT12),
            },
            {
              type_id: "13",
              wasteweigh: checkweight(this.getWaste.CHEMICAL_WEIGHT13),
            },
            {
              type_id: "14",
              wasteweigh: checkweight(this.getWaste.CHEMICAL_WEIGHT14),
            },
            {
              type_id: "21",
              wasteweigh: checkweight(this.getWaste.INFECTIOUS_WEIGHT21),
            },
            {
              type_id: "22",
              wasteweigh: checkweight(this.getWaste.INFECTIOUS_WEIGHT22),
            },
            {
              type_id: "23",
              wasteweigh: checkweight(this.getWaste.INFECTIOUS_WEIGHT23),
            },
            {
              type_id: "24",
              wasteweigh: checkweight(this.getWaste.INFECTIOUS_WEIGHT24),
            },
            {
              type_id: "31",
              wasteweigh: checkweight(this.getWaste.DANGER_WEIGHT31),
            },
            {
              type_id: "32",
              wasteweigh: checkweight(this.getWaste.DANGER_WEIGHT32),
            },
          ],
          signature_pic:
            // "data:image/png;base64,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",
            "iVBORw0KGgoAAAANSUhEUgAAADoAAAAvCAYAAACyoNkAAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAABTSURBVGhD7c+xAYAwDMCw0P9/BoZeoViLZz/vbxY4t7xGNY1qGtU0qmlU06imUU2jmkY1jWoa1TSqaVTTqKZRTaOaRjWNahrVNKppVNOoZsnozAd2rARasdmcIwAAAABJRU5ErkJggg==",
        };

        this.$token_api
          .post("/insert_transaction_custom", Insert_Waste)
          .then((response) => {
            // console.log(response.data);
            //
            this.$swal("บันทึกสำเร็จ", "สำเร็จ", "success");
            this.$router.push({ path: "/wastedocument/waste-document" });
            this.$store.dispatch("Waste/reset");
          })
          .catch((err) => {
            console.error(err);
            this.$swal("กรุณาตรวจสอบข้อมูล", "เกิดข้อผิดพลาด", "error");
          });
      }
    },
    saveupdate() {
      let Update_Waste = {
        CAR_CODE: this.getWaste.W_CARNUMBER.CAR_CODE,
        DRIVER: this.getWaste.W_DRIVER.PERSONNEL_CID,
        CARRIER: this.getWaste.W_CARRIER.PERSONNEL_CID,
        CAR: this.getWaste.W_CARNUMBER.CAR_ID,
        C_CAR: this.getWaste.C_CARNUMBER.CAR_ID,
        // CAR_ID: this.getWaste.W_CARNUMBER.CAR_ID,
        CUSTOMER_ID: this.getWaste.W_NAME.NEWCUSTOMER_ID,
        WALKIN_DATE: this.changeDate(
          this.getWaste.W_DATE_I,
          this.getWaste.W_TIME_I
        ),
        WALKUOT_DATE: this.changeDate(
          this.getWaste.W_DATE_I,
          this.getWaste.W_TIME_O
        ),
        CHANGE_DATE: this.changeDate(
          this.getWaste.C_DATE,
          this.getWaste.C_TIME
        ),
        WALKUOT_WEIGHT: this.getWaste.W_WEIGHT,
        waste_detail: [
          {
            type_id: "11",
            wasteweigh: checkweight(this.getWaste.CHEMICAL_WEIGHT11),
          },
          {
            type_id: "12",
            wasteweigh: checkweight(this.getWaste.CHEMICAL_WEIGHT12),
          },
          {
            type_id: "13",
            wasteweigh: checkweight(this.getWaste.CHEMICAL_WEIGHT13),
          },
          {
            type_id: "14",
            wasteweigh: checkweight(this.getWaste.CHEMICAL_WEIGHT14),
          },
          {
            type_id: "21",
            wasteweigh: checkweight(this.getWaste.INFECTIOUS_WEIGHT21),
          },
          {
            type_id: "22",
            wasteweigh: checkweight(this.getWaste.INFECTIOUS_WEIGHT22),
          },
          {
            type_id: "23",
            wasteweigh: checkweight(this.getWaste.INFECTIOUS_WEIGHT23),
          },
          {
            type_id: "24",
            wasteweigh: checkweight(this.getWaste.INFECTIOUS_WEIGHT24),
          },
          {
            type_id: "31",
            wasteweigh: checkweight(this.getWaste.DANGER_WEIGHT31),
          },
          {
            type_id: "32",
            wasteweigh: checkweight(this.getWaste.DANGER_WEIGHT32),
          },
        ],
        TRANSACTION_ID: this.getWaste.TRANSACTION_ID,
      };

      this.$token_api
        .post("/update_transaction_custom", Update_Waste)
        .then((response) => {
          this.$swal("บันทึกสำเร็จ", "สำเร็จ", "success");
          this.$router.push({ path: "/wastedocument/waste-document" });
          this.$store.dispatch("Waste/reset");
        })
        .catch((err) => {
          console.error(err);
          this.$swal("กรุณาตรวจสอบข้อมูล", "เกิดข้อผิดพลาด", "error");
        });
    },
    listAllCar() {
      this.$token_api
        .get("/list-car-data")
        .then((res) => {
          this.carList = res.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    sCusList() {
      //console.log(this.getWaste.W_NAME);
      this.$token_api
        .post("/sCusList")
        .then((res) => {
          this.cusList = res.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    sDriverList() {
      this.$token_api
        .post("/sDriverList")
        .then((res) => {
          this.driverList = res.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    sCarierList() {
      this.$token_api
        .post("/sCarierList")
        .then((res) => {
          this.carierList = res.data.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    backTO() {
      this.$router.push({ path: "/wastedocument/waste-document" });
      this.$store.dispatch("Waste/reset");
    },
    changeDate(date, time) {
      let valAll = moment(date).format("YYYY-MM-DD ") + time + ":" + "00";
      //console.log(valAll);
      return valAll;
    },
  },
  computed: {
    ...mapGetters({
      GET_IS_EDIT: "Waste/IS_EDIT",
      getWaste: "Waste/GET_WASTEDOC",
    }),
    W_NAME: {
      get() { 
        return this.getWaste.W_NAME.N;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_NAME", value: value });
      },
    },
    W_CARNUMBER: {
      get() {
        return this.getWaste.W_CARNUMBER.CAR_NUMBER;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_CARNUMBER", value: value });
      },
    },
    C_CARNUMBER: {
      get() {
        return this.getWaste.C_CARNUMBER.CAR_NUMBER;
      },
      set(value) {
        this.SET_ELEMENT({ key: "C_CARNUMBER", value: value });
      },
    },
    W_DRIVER: {
      get() {
        return this.getWaste.W_DRIVER.N;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_DRIVER", value: value });
      },
    },
    W_CARRIER: {
      get() {
        return this.getWaste.W_CARRIER.N;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_CARRIER", value: value });
      },
    },
    W_DATE_I: {
      get() {
        return this.getWaste.W_DATE_I;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_DATE_I", value: value });
      },
    },
    C_DATE: {
      get() {
        return this.getWaste.C_DATE;
      },
      set(value) {
        this.SET_ELEMENT({ key: "C_DATE", value: value });
      },
    },
    W_TIME_I: {
      get() {
        return this.getWaste.W_TIME_I;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_TIME_I", value: value });
      },
    },
    W_TIME_O: {
      get() {
        return this.getWaste.W_TIME_O;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_TIME_O", value: value });
      },
    },
    C_TIME: {
      get() {
        return this.getWaste.C_TIME;
      },
      set(value) {
        this.SET_ELEMENT({ key: "C_TIME", value: value });
      },
    },
    W_WEIGHT: {
      get() {
        return this.getWaste.W_WEIGHT;
      },
      set(value) {
        this.SET_ELEMENT({ key: "W_WEIGHT", value: value });
      },
    },
    CHEMICAL_WEIGHT11: {
      get() {
        return this.getWaste.CHEMICAL_WEIGHT11;
      },
      set(value) {
        this.SET_ELEMENT({ key: "CHEMICAL_WEIGHT11", value: value });
      },
    },
    CHEMICAL_WEIGHT12: {
      get() {
        return this.getWaste.CHEMICAL_WEIGHT12;
      },
      set(value) {
        this.SET_ELEMENT({ key: "CHEMICAL_WEIGHT12", value: value });
      },
    },
    CHEMICAL_WEIGHT13: {
      get() {
        return this.getWaste.CHEMICAL_WEIGHT13;
      },
      set(value) {
        this.SET_ELEMENT({ key: "CHEMICAL_WEIGHT13", value: value });
      },
    },
    CHEMICAL_WEIGHT14: {
      get() {
        return this.getWaste.CHEMICAL_WEIGHT14;
      },
      set(value) {
        this.SET_ELEMENT({ key: "CHEMICAL_WEIGHT14", value: value });
      },
    },
    INFECTIOUS_WEIGHT21: {
      get() {
        return this.getWaste.INFECTIOUS_WEIGHT21;
      },
      set(value) {
        this.SET_ELEMENT({ key: "INFECTIOUS_WEIGHT21", value: value });
      },
    },
    INFECTIOUS_WEIGHT22: {
      get() {
        return this.getWaste.INFECTIOUS_WEIGHT22;
      },
      set(value) {
        this.SET_ELEMENT({ key: "INFECTIOUS_WEIGHT22", value: value });
      },
    },
    INFECTIOUS_WEIGHT23: {
      get() {
        return this.getWaste.INFECTIOUS_WEIGHT23;
      },
      set(value) {
        this.SET_ELEMENT({ key: "INFECTIOUS_WEIGHT23", value: value });
      },
    },
    INFECTIOUS_WEIGHT24: {
      get() {
        return this.getWaste.INFECTIOUS_WEIGHT24;
      },
      set(value) {
        this.SET_ELEMENT({ key: "INFECTIOUS_WEIGHT24", value: value });
      },
    },
    DANGER_WEIGHT31: {
      get() {
        return this.getWaste.DANGER_WEIGHT31;
      },
      set(value) {
        this.SET_ELEMENT({ key: "DANGER_WEIGHT31", value: value });
      },
    },
    DANGER_WEIGHT32: {
      get() {
        return this.getWaste.DANGER_WEIGHT32;
      },
      set(value) {
        this.SET_ELEMENT({ key: "DANGER_WEIGHT32", value: value });
      },
    },
  },
  created() {
    this.isEdit = this.GET_IS_EDIT;
    this.listAllCar();
    this.sCusList();
    this.sDriverList();
    this.sCarierList();
    if (this.isEdit) {
      this.list_wasteDocument();
    }
  },
};
function checkweight(weight) {
  if (weight == "" || weight == null) {
    return 0;
  } else {
    return weight;
  }
}
</script>
